import { Search } from '@mui/icons-material';
import type { DisplayColumnDef } from '@tanstack/react-table';

import TableActionColumn from '../TableActionColumn/index';

export default function TableViewDetailsActionColumn<T>(
  columnDef: DisplayColumnDef<T>,
  {
    hrefFn,
    target,
    ariaLabel,
  }: { hrefFn: (row: T) => string; target?: string; ariaLabel?: string | ((row: T) => string) },
) {
  return TableActionColumn<T>(columnDef, {
    hrefFn,
    tooltip: 'Show details',
    target,
    ariaLabel,
    icon: (
      <Search
        color="secondary"
        fontSize="inherit"
      />
    ),
  });
}
